// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { USER_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';

const getState = (state) => state?.APIConfig;

const getSessionState = (state) => state?.session?.siteDetails;

export const getAPIConfigForAdobe = createSelector(getState, (state) => ({
  storeId: state?.storeId,
  brandId: state?.brandId,
  language: state?.language,
  country: state?.countryKey,
}));

export const getSessionDataForAdobe = createSelector(getSessionState, (sessionState) => ({
  language: sessionState?.language,
  country: sessionState?.country,
}));

export const getUserState = (state) => {
  return state[USER_REDUCER_KEY];
};
